import { render } from "./redditRules.vue?vue&type=template&id=61f73270"
import script from "./redditRules.vue?vue&type=script&lang=js"
export * from "./redditRules.vue?vue&type=script&lang=js"

import "./redditRules.vue?vue&type=style&index=0&id=61f73270&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__